import { AxiosInstance, AxiosRequestConfig } from 'axios'
import AxiosBaseRequest from './axios-base'

class HttpClient {
  baseInstance: AxiosInstance
  constructor() {
    this.baseInstance = AxiosBaseRequest.getInstance()
  }

  async get(url: string, config?: AxiosRequestConfig) { return this.baseInstance.get(url, config) }
  async post(url: string, data?: unknown, config?: AxiosRequestConfig) {
    return this.baseInstance.post(url, data, config)
  }

  async delete(url: string, config?: AxiosRequestConfig) { return this.baseInstance.delete(url, config) }
}

export default new HttpClient()
